/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class BoardMainRollRoute extends Route {
  // Services
  @service
  options;

  @service
  store;

  async model() {
    let statuses = JSON.stringify([
      EnrolmentStatus.CURRENT,
      EnrolmentStatus.PENDING,
    ]);
    // The caregivers load first, so eligibleVoters can read each contact's
    // caregiver from the store.
    let model = await hash({
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        statuses,
      }),
      caregivers: this.store.query('person', { type: PersonType.CAREGIVER }),
    });
    model.eligibleVoters = await this.eligibleVoters(model.people);
    return model;
  }

  // eligibleVoters gives one { caregiver, isSupplementary } entry for each
  // caregiver that votes in the board elections.
  async eligibleVoters(people) {
    let mainRollClosingDate = this.options.value(
      'nzMOE:boardElections:mainRollClosingDate',
    );
    let voters = new Map();
    let promiseList = [];
    for (let person of people) {
      for (let contact of person.learner.contacts) {
        if (voters.has(contact.caregiverId)) {
          continue;
        }
        let caregiver = contact.caregiver;
        if (!caregiver || !contact.get('fields.nzMOE:botVoting.value')) {
          continue;
        }

        let lastUpdatedDate = contact.get(
          'fields.nzMOE:botVotingUpdateDate.value',
        );
        let isSupplementary =
          !isEmpty(lastUpdatedDate) &&
          moment(lastUpdatedDate).isAfter(mainRollClosingDate);
        voters.set(contact.caregiverId, { caregiver, isSupplementary });

        // Caregivers of learners who enrol after the main roll closes are
        // supplementary.
        promiseList.push(
          Promise.resolve(person.enrolment).then((enrolment) => {
            if (
              moment.unix(enrolment.updateTime).isAfter(mainRollClosingDate)
            ) {
              voters.set(contact.caregiverId, {
                caregiver,
                isSupplementary: true,
              });
            }
          }),
        );
      }
    }
    // Give the voters also when a recent enrolment does not load.
    await Promise.allSettled(promiseList);
    return [...voters.values()];
  }
}
